import initialState from "./initial"
import {List, fromJS} from "immutable"

const templatesReducer = (state = initialState.templates, action) => {
    if (action.type === "TEMPLATES_LOADING") {
        return state.set("loading", true)
    }
    if (action.type === "TEMPLATES_LOADERROR") {
        return state
            .set("data", List([]))
            .set("loaded", false)
            .set("loading", false)
            .set("loaderror", action.msg)
    }
    if (action.type === "TEMPLATES_LOADED") {
        state = state
            .set("data", fromJS(action.data))
            .set("loaded", true)
            .set("loading", false)
            .set("loaderror", "")
        return state
    }
    return state
}

export default templatesReducer
